export default class Validator {
    static name(value) {
        return value && value.length < 30;
    }

    static email(value) {
        let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return value && regex.test(value) && value.length < 30;
    }

    static phone(value) {
        let regex = /^\(\d{3}\) \d{3}-\d{4}$/;

        return value && regex.test(value) && value.length === 14;

    }

    static comments(value) {
        // not required
        if (!value) return true;

        return value.length < 200;
    }

    static carYear(value) {
        const minYear = 1920;

        return value >= minYear && value <= (new Date(Date.now()).getFullYear() + 1) && Number.isInteger(+value);
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/Validator.js